(function (sb) {
    sb.Constants = (sb.Constants || {});

    // Populated on page load in RHViewStoryboard.aspx
    // Serverside enum values commented
	sb.Constants.itemTypes = {
        HEADER: null, 		// Header = 1
        FOOTER: null, 		// Footer = 2
        CHART: null, 		// Chart = 3
        TEXT: null, 		// Html = 4
        IMAGE: null, 		// Image = 5
        TABLE: null, 		// Table = 6
        LINKEDCHART: null, // Linkedchart = 7
        STATICTEXT: null, // Text = 8
        RESPONDENTTABLE: null, //RespondentTable = 9,
        SIMPLETABLE: null, 	// SimpleTable = 10
        DYNAMICIMAGE: null, //DynamicImage = 11
        WORDCLOUD: null, //WordCloud = 12
        DATAFIELD: null, // DataField = 13
        HEATMAP: null, // HeatMap = 14
        EVENTCREATOR: null, // EventCreator = 15
        ICONSHAPE: null, // IconShape = 16
        DYNAMICICONSHAPE: null, // DynamicIconShape = 17
		CROSSTABLE: null, // CrossTable2.0 = 18
        EMPTYCHARTCREATOR: null, // empty chart creator object = 19
        TAGS: null, // Tags = 20
        SUMMARY: null, // Summary = 21
        ADVANCEDANALYTICS: null, // AdvancedAnalytics = 22
    };

    sb.Constants.chartTemplateImageFolderPath = "images/chartstyle_templates/";
    sb.Constants.respondentTableTemplateImageFolderPath = "images/respondenttable_templates/";
    sb.Constants.wordCloudTemplateImageFolderPath = "images/wordcloud_templates/";

    sb.Constants.itemTypeClearNames = [
        "",
        "header",
        "footer",
        "chart",
        "text &amp; media",
        "image",
        "cross table",
        "linked chart",
        "static text",
        "respondent table ",
        "table",
        "dynamic image ",
        "word cloud ",
        "data field ",
        "heat map ",
        "event creator ",
        "icon / shape ",
        "dynamic icon / shape ",
        "cross table 2.0",
        "empty chart creator",
        "tags",
        "summary",
        "advanced analytics",
    ];

    sb.Constants.documentFormats = {
        PPTONLINE: { hash: 1, layoutWidth: 960, layoutHeight: 720 },
        A4PORTRAIT_LEGACY: { hash: 2, layoutWidth: 796, layoutHeight: 1123 },
        A4LANDSCAPE_LEGACY: { hash: 3, layoutWidth: 1123, layoutHeight: 796 },
        PPT_16_9: { hash: 4, layoutWidth: 1280, layoutHeight: 720 },
        CUSTOM: { hash: 5, layoutWidth: 0, layoutHeight: 0 },
        A4PORTRAIT: { hash: 6, layoutWidth: 796, layoutHeight: 1123 },
        A4LANDSCAPE: { hash: 7, layoutWidth: 1123, layoutHeight: 796 },
        SMALLSCREEN: { hash: 8, layoutWidth: 350, layoutHeight: 500 },

        getDocFormat: function (type) {
            switch (type) {
                case this.PPTONLINE.hash:
                    return this.PPTONLINE;
                case this.A4PORTRAIT_LEGACY.hash:
                    return this.A4PORTRAIT_LEGACY;
                case this.A4LANDSCAPE_LEGACY.hash:
                    return this.A4LANDSCAPE_LEGACY;
                case this.PPT_16_9.hash:
                    return this.PPT_16_9;
                case this.A4PORTRAIT.hash:
                    return this.A4PORTRAIT;
                case this.A4LANDSCAPE.hash:
                    return this.A4LANDSCAPE;
                case this.SMALLSCREEN.hash:
                    return this.SMALLSCREEN;
                default:
                    return this.CUSTOM;
            }
        }
    }

    sb.Constants.areaMinSize = 300;
    sb.Constants.gridStepSize = 5;
    sb.Constants.boxMinSize = { width: 15, height: 15 };
    sb.Constants.zIndexBase = 21;
    sb.Constants.maxLayoutElements = 200;

    sb.Constants.CalculationTypes = {
        CATEGORICAL_PERCENT: 1,
        CATEGORICAL_MEAN: 2,
        NUMERIC_AVERAGE: 3,
        NUMERIC_SUM: 4,
        EXTERNAL_DATA: 5,
        CORRELATION_ANALYSIS: 6,
        CATEGORICAL_COUNT: 7,
        NUMERIC_MIN: 8,
        NUMERIC_MAX: 9,
        NUMERIC_MEDIAN: 10,
        NUMERIC_PERCENT: 11,
        NUMERIC_STANDARD_DEVIATION: 13,
        CATEGORICAL_STANDARD_DEVIATION: 14,

		isNumeric: function (v) {
			return v == this.NUMERIC_AVERAGE || v == this.NUMERIC_SUM || v == this.NUMERIC_MIN || v == this.NUMERIC_MAX ||
				v == this.NUMERIC_MEDIAN || v == this.NUMERIC_PERCENT;
		},
        isAnswerBased: function (v) { return v == this.CATEGORICAL_PERCENT || v == this.CATEGORICAL_COUNT; }
    };

    sb.Constants.ColorSources = {
        QUESTION: 1,
        ANSWER: 2,
        COLOR_TEMPLATE: 3,
        FILTER: 4,
        SINGLE_COLOR: 5,
        AUTO: 6,
		DYNAMIC_COLORS: 7,
        HFILTER_RULE: 8,
        VALUE_BASED: 9
    };

    sb.Constants.ColorSourcesScatter = {
        QuestionColourFromX: 1,
        AnswerColourFromX: 2,
        QuestionColourFromY: 3,
        AnswerColourFromY: 4,
        ColourTemplate: 5,
        SingleColor: 6,
        MeanQuadrantColour: 7
    };


    sb.Constants.SeriesTypes = {
        LINE: 1,
        BAR: 2,
        COLUMN: 3,
        SPLINE: 4,
        AREA: 5,
        VERTICALLINE: 6,
        VERTICALSPLINE: 7,
        PIE: 8,
        DONUT: 9,
        SCATTER: 10,
		BUBBLE: 11,
		VERTICALAREA: 12,
        GAUGE: 13,
        SOLIDGAUGE: 14,
        TREEMAP: 15,
        HEATMAP: 16,
        MARIMEKKO: 17,
        FUNNEL: 18,

        isScatterLike: function (st) { return st == this.SCATTER || st == this.BUBBLE; },
        isStackable: function (s) { return s != this.GAUGE && s != this.SCATTER && s != this.BUBBLE && s != this.FUNNEL; },
        hasHorizontalXAxis: function (st) { return st == this.COLUMN || st == this.LINE || st == this.AREA || st == this.SPLINE },
        canBePolar: function (st) { return st != this.PIE && st != this.DONUT && st != this.GAUGE && st != this.SOLIDGAUGE && st != this.MARIMEKKO },
        isLineOrAreaBased: function (st) { return st != this.BAR && st != this.COLUMN && st != this.PIE && st != this.DONUT && st != this.GAUGE && st != this.SOLIDGAUGE && st != this.SCATTER && st != this.BUBBLE && st != this.FUNNEL; },
        canUseTwoColorLogic: function (st, stacking) {
            var isChartCreator = window.ContentType > 0 && window.ContentType === Storyboard.Constants.itemTypes.CHART;
            var align = isChartCreator ? $("#cc_chartstyle_series_dataLabels_align button.active").val() : $("#chartstyle_series_dataLabels_align").val();
            var distance = isChartCreator ? $("#cc_chartstyle_series_dataLabels_distance button.active").val() : $("#chartstyle_series_dataLabels_distance").val();

			return ((st == this.TREEMAP && $('#ddlColorLogic').val() != "7") ||				
				(st == this.BAR || st == this.COLUMN || st == this.MARIMEKKO) && (stacking !== 0 || align != "right")) ||
				((st == this.PIE || st == this.DONUT) && distance == "-30");
		},
		canUseSeriesBorder: function (st) {
            return st == this.BAR || st == this.COLUMN || st == this.PIE || st == this.DONUT || st == this.SOLIDGAUGE || st == this.TREEMAP || st == this.HEATMAP || st == this.MARIMEKKO || st == this.FUNNEL;
		},
		canUseSeriesShadow: function (st) {
            return st == this.BAR || st == this.COLUMN || st == this.LINE || st == this.VERTICALLINE || st == this.SPLINE || st == this.VERTICALSPLINE || st == this.AREA || st == this.VERTICALAREA || st == this.PIE || st == this.DONUT || st == this.FUNNEL;
		},
		canUsePosNeg: function (st) {
			return st != this.PIE && st != this.DONUT && st != this.TREEMAP && st != this.MARIMEKKO;
		}
    };

    sb.Constants.SeriesLayout = {
        None: 0,
        SliceAndDice: 1,
        Stripes: 2,
        Squarified: 3,
        Strip: 4
    };

    sb.Constants.BaseSizePosition = {
        Auto: 1,
        Axis: 2,
        Legend: 3,
        Series: 4
    };

    sb.Constants.LegendPosition = {
        Top: 1,
        Bottom: 2,
        Left: 3,
        Right: 4,
        Hide: 5,
        DataLabel: 6
    };

    sb.Constants.BenchmarkDimension = {
        Legend: 1,
        Axis: 2
    };

    sb.Constants.ZTestBetween = {
        LegendItems: 1,
        AxisGroups: 2
    };

    sb.Constants.MeanValueOrientation = {
        Axis: 1,
        Legend: 2
    };

    sb.Constants.IntervalTypes = {
        DAY: 1,
        WEEK: 2,
        MONTH: 3,
        QUARTER: 4,
        HALF_YEAR: 5,
        YEAR: 6,
        FULL_PERIOD: 7
    };

    sb.Constants.CTRenderType = {
        ALL_FORMATTING: 1,
        NO_FORMATTING_RULES: 2,
        NO_DESIGNER_FORMATTING: 3,
        UNFORMATTED: 4
    };

    sb.Constants.GroupTypes = {
        QUESTION: 1,
        TIMEPERIOD: 2,
        FILTER: 3,
        ANSWER: 4,
        SPLIT: 9,
        QUESTION_VAL: "question",
        ANSWER_VAL: "answer",
        TIMEPERIOD_VAL: "timeperiod",
        FILTER_VAL: "",
        SPLIT_VAL: "",

        getGroupItem: function (value, position, sortOrder, sortValue, text, groupType) {
            return {
                value: value,
                position: position,
                sortOrder: sortOrder,
                sortValue: sortValue || "",
                groupType: groupType || this.getGroupType(value),
                text: this.getGroupText(value, text)
            };
        },
        getGroupType: function (value) {
            value = ("" + value).toLowerCase();
            if (value == this.QUESTION_VAL)
                return 1;
            else if (value == this.ANSWER_VAL)
                return 4;
            else if (value == this.TIMEPERIOD_VAL)
                return 2;
            else if (!isNaN(parseInt(value, 10)) && parseInt(value, 10) >= 0)
                return 3; //filter
            else
                return 0;
		},
		getSmartLogicSortOrder: function (value) {
			value = ("" + value).toLowerCase();
			if (value == this.QUESTION_VAL)
				return 2;
			else if (value == this.ANSWER_VAL)
				return 3;
			else if (value == this.TIMEPERIOD_VAL)
				return $("#ddlInterval_cc").val() != 7 ? 4 : 1;
			else if (!isNaN(parseInt(value, 10)) && parseInt(value, 10) >= 0)
				return 5; //filter
			else
				return 0;
		},
        getGroupText: function (value, text) {
            value = ("" + value).toLowerCase();
			if (value == this.QUESTION_VAL)
				return "Question";
			else if (value == this.ANSWER_VAL)
				return "Answer";
			else if (value == this.TIMEPERIOD_VAL)
				return "Interval";
			else if (value == "0") {
				if (window.IsChartCreator)
					return $('.hfilterSelectionHeader div.h4').text();
				return "H-Filter";
			} else if (value == this.SPLIT && window.ContentType > 0)
                return "Split";
            else
                return text;
        }
    };

    sb.Constants.Axis = {
        legend: 1,
        axis: 2
    };

    sb.Constants.arrangeDirections = {
        FRONT: "front",
        FORWARD: "forward",
        BACKWARD: "backward",
        BACK: "back"
    }

    sb.Constants.ChartFlags = {
        CODE_NODATA: 1,
        CODE_NOTPRELOADED: 4
    };

    sb.Constants.HFilterSelectionModes = {
        SINGLE: 1,
        MULTIPLE: 2,
        ADVANCED: 3
    };

    sb.Constants.HFilterLayouts = {
        HFILTERLIST: 1,
        HFILTERMULTIBOX: 2,
        HFILTERLISTPERLEVEL: 3,
        HFILTERTREE: 4
    };

    sb.Constants.Attributes = {
        None: 0,
        IsTopNode: 1,
        IsVisible: 2,
        IsUserEnabled: 4,
        IsDefaultSelected: 8,
        IsBranchExpanded: 16,
        IsBranchEnabled: 32,
        IsPreloadEnabled: 64
    };

    sb.Constants.OptionalChartSettingsFlags = {
        None: 0,
        All: 1,
        Select: 2,
        Report: 3
    };

    sb.Constants.OptionalChartGeneralSettings = {
        None: parseInt(0 || 0, 10),
        ShowQuestionBlocks: parseInt(1 || 0, 10),
        ShowQuestions: parseInt(2 || 0, 10),
        ShowAnswers: parseInt(4 || 0, 10),
        ShowCalculationTypes: parseInt(8 || 0, 10)
    };

    sb.Constants.SettingTypes = {
        None: 0,
        VariableSubset: 1,
        Interval: 2,
        TimePeriod: 3,
        MovingAverage: 4,
        Filter: 5,
        HFilter: 6,
		Language: 7,
		DeckHFilter: 8,
		RefDataFilter: 9,

        getTypeText: function (settingType) {
            switch (settingType) {
                case this.VariableSubset:
                    return "Variable subset";
                case this.Interval:
                    return "Interval";
                case this.TimePeriod:
                    return "Time periods";
                case this.MovingAverage:
                    return "Moving average";
                case this.Filter:
                    return "Filters";
                case this.HFilter:
                    return "Hierarchical filters";
                case this.None:
                default:
                    return "None";
            }
        }
    };

    sb.Constants.ContentLoadType = {
        CurrentSlide: 1,
        CurrentAndAdjacent: 2,
        All: 3,
        Translated: 4
    };

    sb.Constants.DynamicIconShapeCompareTypes = {
        SingleResult: 1,
        Questions: 2,
        Answers: 3,
        CompareFilter: 4,
        Intervals: 5
    };

    sb.Constants.TemplateItemTypes = {
        Folder: 1,
        Element: 2,
        Group: 3,
        Slide: 4,
        Report: 5,
        BackgroundSlide: 6,

        getTypeText: function (templateType) {
            switch (templateType) {
                case this.Folder:
                    return "Folder";
                case this.Element:
                    return "Object";
                case this.Group:
                    return "Group";
                case this.Slide:
                    return "Slide";
                case this.Report:
                    return "Report";
                case this.BackgroundSlide:
                    return "Slide background";
                default:
                    return "";
            }
        }
    };

    sb.Constants.DataFieldControlTypes = {
        Unknown: 0,
        Input: 1,
        DropDownSingle: 2,
        DropDownMultiple: 3,
        DropDownNumeric: 4,
        SelectBoxSingle: 5,
        SelectBoxMultiple: 6,
        RowCheckboxes: 7,
        ColumnCheckboxes: 8,
        RowRadios: 9,
        ColumnRadios: 10,
        TextArea: 11,
        Calendar: 12,

        getTypeText: function (controlType) {
            switch (parseInt(controlType, 10)) {
                case this.Input:
                    return "Input field";
                case this.DropDownSingle:
                case this.DropDownMultiple:
                case this.DropDownNumeric:
                    return "Dropdown list";
                case this.SelectBoxSingle:
                case this.SelectBoxMultiple:
                    return "Select box";
                case this.RowCheckboxes:
                    return "Checkboxes in row";
                case this.ColumnCheckboxes:
                    return "Checkboxes in column";
                case this.RowRadios:
                    return "Radios in row";
                case this.ColumnRadios:
                    return "Radios in Column";
                case this.TextArea:
                    return "Text area";
                case this.Calendar:
                    return "Calendar";
                default:
                    return "Static text";
            }
        },

        getTypesForBinding: function (types) {
            var options = [];
            $(types).each(function () { options.push({ id: this, label: Storyboard.Constants.DataFieldControlTypes.getTypeText(this) }); });
            return options;
        }
    };

    sb.Constants.TemplateVersions = {
        Base: 0,
        SlidesConcept: 1
    };

    sb.Constants.AnalysisTypes = {
        TWO_INDEPENDENT_SAMPLE_Z_TEST: 1,
		NORM_TEST: 2,
        TWO_INDEPENDENT_SAMPLE_T_TEST: 3,
        PAIRED_Z_TEST: 4,
        PAIRED_T_TEST: 5
    };

    sb.Constants.DynamicFilteringStatus = {
        Off: 0,
        OnDisableOptionsWithNoData: 1,
        OnHideOptionsWithNoData: 2
    };

    sb.Constants.SeriesOptions = {
        SideBySide: 0,
        Stacked: 1,
        FullStacked: 2
    };

    sb.Constants.SeriesUnitPlacement = {
        Suffix: 0,
        Prefix: 1,
        Replace: 2
    },

    sb.Constants.GradientTypes = {
        FixedScale: 1,
        DynamicScale: 2
    };

	sb.Constants.FavoriteSharingType = {
		None: 0,
		AllUsers: 1,
		IndividualUsersWithinGroup: 2,
		AllIndividualUsers: 4,
		OwnGroup: 8,
		AllGroups: 16,
		IndividualAdmins: 32,

		hasUserSharingTypeFlag: function (sharingType) {
			return (sharingType & this.AllIndividualUsers) == this.AllIndividualUsers ||
				(sharingType & this.IndividualUsersWithinGroup) == this.IndividualUsersWithinGroup ||
				(sharingType & this.IndividualAdmins) == this.IndividualAdmins;
		},

		getCTFavoriteText: function (favorite) {
			var sharingType = favorite.sharingType;

			if (this.hasUserSharingTypeFlag(sharingType))
				return locale.get('Shared with {{N}} user(s)').replace('{{N}}', favorite.sharedWithUsers ? favorite.sharedWithUsers.length : 0);

			switch (parseInt(sharingType, 10)) {
				case this.AllUsers:
					return locale.get('Shared with all users');
				case this.OwnGroup:
					return locale.get('Shared with own group');
				case this.AllGroups:
					return locale.get('Shared with {{N}} group(s)').replace('{{N}}', favorite.sharedWithUsers ? favorite.sharedWithUsers.length : 0);
				default:
					return locale.get('Not shared');
			}
		}
	};

	sb.Constants.AvailableRefDataSetsType = {
		All: 0,
		FilterAndHFilterCombination: 1,
		HFilter: 2,
		Filter: 4,
		FiltersCombination: 8,

		usesHFilter: function (type) {
			return	(type & this.FilterAndHFilterCombination) == this.FilterAndHFilterCombination ||
					(type & this.HFilter) == this.HFilter;
		},

		usesFilter: function (type) {
			return	(type & this.FilterAndHFilterCombination) == this.FilterAndHFilterCombination ||
					(type & this.Filter) == this.Filter ||
					(type & this.FiltersCombination) == this.FiltersCombination;
		}
	};

	sb.Constants.FavoriteEditStatus = {
		NotEditable: 0,
		Editable: 1,
		Locked: 2,
		ActiveEdit: 3
	},

    sb.Constants.DaysInMonth = {
        "0": 0,
        "1": 1 << 0,
        "2": 1 << 1,
        "3": 1 << 2,
        "4": 1 << 3,
        "5": 1 << 4,
        "6": 1 << 5,
        "7": 1 << 6,
        "8": 1 << 7,
        "9": 1 << 8,
        "10": 1 << 9,
        "11": 1 << 10,
        "12": 1 << 11,
        "13": 1 << 12,
        "14": 1 << 13,
        "15": 1 << 14,
        "16": 1 << 15,
        "17": 1 << 16,
        "18": 1 << 17,
        "19": 1 << 18,
        "20": 1 << 19,
        "21": 1 << 20,
        "22": 1 << 21,
        "23": 1 << 22,
        "24": 1 << 23,
        "25": 1 << 24,
        "26": 1 << 25,
        "27": 1 << 26,
        "28": 1 << 27,
        "29": 1 << 28,
        "30": 1 << 29,
        "31": 1 << 30,
    }

    sb.Constants.DaysInMonth.All =
        sb.Constants.DaysInMonth["1"] |
        sb.Constants.DaysInMonth["2"] |
        sb.Constants.DaysInMonth["3"] |
        sb.Constants.DaysInMonth["4"] |
        sb.Constants.DaysInMonth["5"] |
        sb.Constants.DaysInMonth["6"] |
        sb.Constants.DaysInMonth["7"] |
        sb.Constants.DaysInMonth["8"] |
        sb.Constants.DaysInMonth["9"] |
        sb.Constants.DaysInMonth["10"] |
        sb.Constants.DaysInMonth["11"] |
        sb.Constants.DaysInMonth["12"] |
        sb.Constants.DaysInMonth["13"] |
        sb.Constants.DaysInMonth["14"] |
        sb.Constants.DaysInMonth["15"] |
        sb.Constants.DaysInMonth["16"] |
        sb.Constants.DaysInMonth["17"] |
        sb.Constants.DaysInMonth["18"] |
        sb.Constants.DaysInMonth["19"] |
        sb.Constants.DaysInMonth["20"] |
        sb.Constants.DaysInMonth["21"] |
        sb.Constants.DaysInMonth["22"] |
        sb.Constants.DaysInMonth["23"] |
        sb.Constants.DaysInMonth["24"] |
        sb.Constants.DaysInMonth["25"] |
        sb.Constants.DaysInMonth["26"] |
        sb.Constants.DaysInMonth["27"] |
        sb.Constants.DaysInMonth["28"] |
        sb.Constants.DaysInMonth["29"] |
        sb.Constants.DaysInMonth["30"] |
        sb.Constants.DaysInMonth["31"];

    sb.Constants.ProjectFeaturesEnum = {
        None: 0,
        Enfesys: 1,
        MultiLanguages: 2,
        HierarchySupport: 4,
        HierarchyBulkExport: 8,
        LinkedProjects: 16,
        OpenAnswer: 32,
        ReportUsers: 64,
        StoryTeller: 128
    };

    sb.Constants.LayoutElementVersion = {
        Initial: 1,
        TFS22340: 2
    };

   sb.Constants.Events = Object.freeze({
        SIDEPANEL_OPEN: 'vis-re-sidepanel-open',
        SIDEPANEL_CLOSE: 'vis-re-sidepanel-close',
        ITEM_SIDEPANEL_OPEN: 'vis-re-item-sidepanel-open',
        ITEM_SIDEPANEL_CLOSE: 'vis-re-item-sidepanel-close',
        ITEM_EDIT_MODE: 'vis-re-item-edit-mode',
        LAYOUT_INFO_LOADED: 'viz-r-layout-info-loaded',
        LOAD_COORDINATES_COMPLETE: 'viz-r-load-coordinates-complete',
        SLIDE_OPENED: 'viz-r-slide-opened',
        LAYOUT_ELEMENT_SELECTED: 'viz-r-layout-element-selected',
        LAYOUT_ELEMENT_DESELECTED: 'viz-r-layout-element-deselected',
        GENERAL_SETTINGS_LOADED: 'viz-r-general-settings-loaded',
        GENERAL_SETTINGS_SAVED: 'viz-r-general-settings-saved',
        HFILTER_SLIDE_EXCLUSIONS_LOADED: 'viz-re-hfilter-slide-exclusions-loaded',
        SET_IS_UNSAVED: 'viz-re-set-is-unsaved',
        SET_TEMPLATE_OPTIONS: 'viz-re-set-template-options',
        BACKGROUND_SLIDE_OPENED: 'viz-re-background-slide-opened',
        BACKGROUND_SLIDE_CLOSED: 'viz-re-background-slide-closed',
        FORMAT_SETTINGS_UPDATED: 'viz-re-format-settings-updated',
        OPEN_CONTEXT_MENU: 'viz-re-open-context-menu',
        CLOSE_MENUS: 'viz-re-close-menus',
        LIBRARY_ICON_SETUP_SAVED: 'viz-re-library-icon-setup-saved',
    });

    sb.Constants.aiIconEntity = '&#xe92f;';

})(window.Storyboard = (window.Storyboard || {}));